import defaultApi from '@/utils/request';

export default {
  // ========================================================================================================
  // S41W2001 學生網路請假作業
  S41W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2001_Load',
      params,
    });
  },
  S41W2001_LeaveViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2001_LeaveViewLoad',
      params,
    });
  },
  S41W2001_UnitSelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2001_UnitSelectorLoad',
      params,
    });
  },
  S41W2001_TeacherSelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2001_TeacherSelectorLoad',
      params,
    });
  },
  S41W2001_MentalHealthSelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2001_MentalHealthSelectorLoad',
      params,
    });
  },
  S41W2001_LeaveViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2001_LeaveViewAction',
      data,
    });
  },
  S41W2001_LeaveViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2001_LeaveViewDelete',
      data,
    });
  },
  S41W2001_LeaveViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2001_LeaveViewSend',
      data,
    });
  },
  S41W2001_LeaveProgressViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2001_LeaveProgressViewLoad',
      params,
    });
  },
  S41W2001_LeaveAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2001_LeaveAttachmentViewLoad',
      params,
    });
  },
  S41W2001_LeaveAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2001_LeaveAttachmentViewFileUpload',
      data,
    });
  },
  S41W2001_LeaveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2001_LeaveAttachmentViewFileDelete',
      data,
    });
  },
  S41W2001_LeaveSignViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2001_LeaveSignViewLoad',
      params,
    });
  },

  // ========================================================================================================
  // S41W2005 操行成績登錄作業
  S41W2005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2005_Load',
      params,
    });
  },
  S41W2005_getConGrade(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2005_getConGrade',
      params,
    });
  },
  S41W2005_doTrans(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2005_doTrans',
      data,
    });
  },
  S41W2005_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2005_SaveApply',
      data,
    });
  },
  S41W2005_GetPDF(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2005_GetPDF',
      responseType: 'blob',
      data,
    });
  },

  // ========================================================================================================
  // S41W3001 老師批次申請學生公假
  S41W3001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W3001_Load',
      params,
    });
  },
  S41W3001_LoadView(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W3001_LoadView',
      params,
    });
  },
  S41W3001_QueryStu(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W3001_QueryStu',
      params,
    });
  },
  S41W3001_LeaveViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W3001_LeaveViewAction',
      data,
    });
  },
  S41W3001_QueryWebnotes(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W3001_QueryWebnotes',
      params,
    });
  },
  S41W3001_SaveVerify(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W3001_SaveVerify',
      data,
    });
  },
  S41W3001_LeaveProgressViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W3001_LeaveProgressViewLoad',
      params,
    });
  },
  S41W3001_LeaveViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W3001_LeaveViewDelete',
      data,
    });
  },
  S41W3001_LeaveAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W3001_LeaveAttachmentViewLoad',
      params,
    });
  },
  S41W3001_LeaveAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W3001_LeaveAttachmentViewFileUpload',
      data,
    });
  },
  S41W3001_LeaveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W3001_LeaveAttachmentViewFileDelete',
      data,
    });
  },
  S41W3001_LeaveViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W3001_LeaveViewLoad',
      params,
    });
  },

  // ========================================================================================================
  // S41W2002 學生重大集會
  S41W2002_ChkS41ClsmAuth(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2002_ChkS41ClsmAuth',
      params,
    });
  },
  S41W2002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2002_Load',
      params,
    });
  },
  S41W2002_LoadView(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2002_LoadView',
      params,
    });
  },
  S41W2002_LoadSelfList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2002_LoadSelfList',
      params,
    });
  },
  S41W2002_QueryStu(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2002_QueryStu',
      params,
    });
  },
  S41W2002_LeaveViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2002_LeaveViewAction',
      data,
    });
  },
  S41W2002_QueryWebnotes(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2002_QueryWebnotes',
      params,
    });
  },
  S41W2002_LeaveProgressViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2002_LeaveProgressViewLoad',
      params,
    });
  },
  S41W2002_KdSelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2002_KdSelectorLoad',
      params,
    });
  },
  S41W2002_LeaveViewDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2002_LeaveViewDelete',
      data,
    });
  },
  S41W2002_SaveVerify(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2002_SaveVerify',
      data,
    });
  },

  // S41W9003 學生重大集會 簽核
  S41W9003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W9003_Load',
      params,
    });
  },
  S41W9003_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W9003_SaveApply',
      data,
    });
  },

  // ========================================================================================================
  // S41W4001 缺曠查詢
  S41W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4001_Load',
      params,
    });
  },
  S41W4001_LoadMemo() {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4001_LoadMemo',
    });
  },
  // ========================================================================================================
  // S41W4002 獎懲查詢
  S41W4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4002_Load',
      params,
    });
  },
  // ========================================================================================================
  // S41W4003 學生歷年服務時數及課外活動記錄
  S41W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4003_Load',
      params,
    });
  },
  // ========================================================================================================
  // S41W4004 歷年操行成績查詢
  S41W4004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4004_Load',
      params,
    });
  },
  // ========================================================================================================
  // S41W4005 歷年幹部查詢
  S41W4005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4005_Load',
      params,
    });
  },
  // ========================================================================================================
  // S41W4009 導師班學生查詢
  S41W4009_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_Load',
      params,
    });
  },
  S41W4009_Get_ClsList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_Get_ClsList',
      params,
    });
  },
  S41W4009_GetDailylog(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_getDailylog',
      params,
    });
  },
  S41W4009_GetStudata(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_getStudata',
      params,
    });
  },
  S41W4009_ScoreViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_ScoreViewLoad',
      params,
    });
  },
  S41W4009_s41ScoreViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_s41ScoreViewLoad',
      params,
    });
  },
  S41W4009_s41RewViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_s41RewViewLoad',
      params,
    });
  },
  S41W4009_s42ViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_s42ViewLoad',
      params,
    });
  },
  S41W4009_s49ViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_s49ViewLoad',
      params,
    });
  },
  S41W4009_s305ViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S41W4009_s305ViewLoad',
      params,
    });
  },

  // S419W4001 歷年導師評量成績查詢
  S419W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S419W4001_Load',
      params,
    });
  },
  S419W4001_initLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S419W4001_initLoad',
      params,
    });
  },
  S419W4001_Show_Detail(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S419W4001_Show_Detail',
      params,
    });
  },
  S419W4001_Get_PrtPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S41/S419W4001_Get_PrtPDF',
      responseType: 'blob',
      params,
    });
  },

  // ----------------- S41W2003 任課老師登錄學生勤缺 ---------------------------------------------
  S41W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2003_Load',
      params,
    });
  },
  S41W2003_LoadView(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2003_LoadView',
      params,
    });
  },
  S41W2003_StuListViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2003_StuListViewLoad',
      params,
    });
  },
  S41W2003_SaveAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2003_SaveAction',
      data,
    });
  },
  S41W2003_SendAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W2003_SendAction',
      data,
    });
  },
  S41W2003_StuQueryViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2003_StuQueryViewLoad',
      params,
    });
  },
  S41W2003_StuQueryView(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2003_StuQueryView',
      params,
    });
  },
  S41W2003_GetPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W2003_GetPDF',
      responseType: 'blob',
      params,
    });
  },
  // ============================== S41W9001 ==================================
  // S41W9001 教師核假作業(新版)
  S41W9001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W9001_Load',
      params,
    });
  },
  S41W9001_DetailViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W9001_DetailViewLoad',
      params,
    });
  },
  S41W9001_DetailViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W9001_DetailViewSend',
      data,
    });
  },
  S41W9001_LeaveSignViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W9001_LeaveSignViewLoad',
      params,
    });
  },
  S41W9001_LeaveFileViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W9001_LeaveFileViewLoad',
      params,
    });
  },
  S41W9001_LeaveContactViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S41/S41W9001_LeaveContactViewLoad',
      params,
    });
  },
  S41W9001_LeaveContactViewSend(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S41/S41W9001_LeaveContactViewSend',
      data,
    });
  },
};
